var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5006 31.36C24.9837 31.36 31.8606 24.4831 31.8606 16C31.8606 7.51692 24.9837 0.640015 16.5006 0.640015C8.01753 0.640015 1.14062 7.51692 1.14062 16C1.14062 24.4831 8.01753 31.36 16.5006 31.36Z",
    fill: "#5F85BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5012 29.2909C9.17318 29.2909 3.21094 23.3287 3.21094 16C3.21094 8.67202 9.17318 2.70978 16.5012 2.70978C23.8292 2.70978 29.7914 8.67202 29.7914 16C29.7914 23.3287 23.8292 29.2909 16.5012 29.2909Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4975 9.89246C13.1298 9.89246 10.3906 12.6323 10.3906 16C10.3906 19.3677 13.1298 22.1075 16.4975 22.1075C19.8652 22.1075 22.605 19.3677 22.605 16C22.6057 12.6329 19.8652 9.89246 16.4975 9.89246ZM16.4975 21.3401C13.5535 21.3401 11.158 18.9446 11.158 16C11.158 13.0553 13.5535 10.6598 16.4975 10.6598C19.4421 10.6598 21.8377 13.0553 21.8377 16C21.8377 18.9446 19.4428 21.3401 16.4975 21.3401Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8326 8.14275L14.2422 13.7415L18.7587 18.2579L24.358 8.66691C24.5564 8.32707 24.1731 7.94371 23.8326 8.14275Z",
    fill: "#3F7CDB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.24 13.7415L8.64061 23.3325C8.44157 23.673 8.82493 24.0563 9.16541 23.8573L18.7558 18.2579L14.24 13.7415Z",
    fill: "#6198ED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5019 14.1465C16.0105 14.1472 15.5395 14.3427 15.192 14.6902C14.8446 15.0376 14.6491 15.5086 14.6484 16C14.6484 17.0221 15.4798 17.8534 16.5019 17.8534C17.524 17.8534 18.3553 17.0221 18.3553 16C18.3546 15.5086 18.1591 15.0376 17.8117 14.6902C17.4643 14.3427 16.9932 14.1472 16.5019 14.1465Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5098 2.39038H18.4913L16.5015 6.37054L14.5098 2.39038ZM14.5111 29.6096L16.5009 25.6294L18.4919 29.6102L14.5111 29.6096ZM26.1303 16.0006L30.1111 14.0096V17.9904L26.1303 16.0006ZM2.89126 14.0102L6.87143 16L2.89062 17.9904L2.89126 14.0102Z",
    fill: "#5F85BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.1c63af6e94a3cd8a545e13addd2a2365.svg";
export { ForwardRef as ReactComponent };